import { Model, View, ViewConfig } from '@lernetz/ts-lib';
import template from './RawHtml.html';

export class RawHtml extends Model {

    public readonly caption: string;
    public readonly html: string;
    public readonly widthStyle: string;

    public constructor( dto ) {
        super( dto );
        this.caption = dto.caption;
        this.html = dto.html;
        this.widthStyle = dto.widthStyle || '';

        this.html = this.html.replace( /\>\s+\</g, '><' ).replace( /^\s+|\s+$/g, '' );
    }
}

export class RawHtmlView extends View<RawHtml> {

    public constructor( config?: ViewConfig<RawHtml> ) {
        super( { template, ...config } );
    }
}
